







































































import Vue from 'vue'
import { Button } from 'element-ui'
import env from '@/env'
import fb from '@/firebase'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { Team } from '@/types/teams'
import KisweInput from '@/components/Kiswe/KisweInput'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'

import './FtpSettings.scss'

export default Vue.extend({
  name: 'FtpSettings',
  data: () => ({
    showEditPassword: false,
    showFailedMessage: false,
    isProcessing: false,
    port: '2121',
    password: '',
    hosts: {
      dev: 'dev-ftp-asset-manager.kiswe.com',
      stage: 'stage-ftp-asset-manager.kiswe.com',
      prod: 'ftp-asset-manager.kiswe.com',
      default: 'ftp-asset-manager.kiswe.com'
    },
  }),
  computed: {
    canSeeFtp (): boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.Ftp)
    },
    canEditFtp (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.Ftp)
    },
    team (): Team | undefined {
      return this.$store.direct.state.team.team
    },
    host (): string {
      const host = this.hosts[env.environment]
      if (host) return host
      return this.hosts.default
    },
    username (): string {
      if (!this.team?.name) return ''
      return this.team.name.replace(/[\W_]+/g, '_')
    },
  },
  methods: {
    setPassword (): void {

      this.isProcessing = true
      this.showFailedMessage = false

      if (this.team === undefined) return
      if (this.password.length < 8) {
        this.password = ''
        this.showFailedMessage = true
        this.isProcessing = false
        this.$message({
          type: 'error',
          message: 'Your FTP password needs to be at least 8 characters.'
        })
        return
      }

      const setFtpPasswordFB = fb.functions.httpsCallable('setFtpPassword')
      const params = {
        teamid: this.team.id,
        ftpusername: this.username,
        ftpp: this.password
      }

      setFtpPasswordFB(params).then(() => {
        this.password = ''
        this.showEditPassword = false
        this.showFailedMessage = false
        this.isProcessing = false
        this.$message({
          type: 'success',
          message: 'Your FTP password has been set'
        })
      }).catch(() => {
        this.password = ''
        this.showFailedMessage = true
        this.isProcessing = false
        this.$message({
          type: 'error',
          message: 'Something went wrong while updating your FTP password. Please try again.'
        })
      })
    }
  },
  components: {
    KisweInput,
    'clip-loader': ClipLoader,
    'el-button': Button
  }
})
